import { getLanguage } from '@languages/index';
import Button from 'components/button';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapDispatchProps, mapStateToProps } from 'store/store';
import API from 'api';
import dayjs from 'dayjs';
import { LOCALES } from 'constants/locales';
import { getServiceName } from 'constants/service/service';

interface TEncourageAllowOtherBrandTagPanel {
  showAlert?: any;
  showPopup?: any;
  closePopup?: any;
  showModal?: any;
  hideBlockButton?: any;
  brand?: any;
  showOverlays?: any;
  type?: any;
  title?: any;
  onHide?: any;
  isPanelVisible?: any;
  setPreferences?: any;
  preferences?: any;
  auth?: any;
}

const EncourageAllowOtherBrandTagPanel = (props: TEncourageAllowOtherBrandTagPanel) => {
  const bannerImage =
    getLanguage() === LOCALES.JA
      ? '/assets/images/banners/encourage-allow-other-brand-tags.png'
      : '/assets/images/banners/encourage-allow-other-brand-tags.png';

  const [isPanelVisible, setIsPanelVisible] = useState(false);

  useEffect(() => {
    if (props.isPanelVisible != isPanelVisible) {
      setIsPanelVisible(props.isPanelVisible);
    }
  }, [props.isPanelVisible]);

  useEffect(() => {
    if (props.showAlert) {
      showAlert();
    }
  }, [props.showAlert]);

  const isBlocked = () => {
    const blockedAt = props.preferences.encourageAllowOtherBrandTagBlockedAt;
    if (!blockedAt) return false;
    const now = dayjs();
    const unblockTime = dayjs(blockedAt).add(7, 'day');
    return now.isBefore(unblockTime);
  };

  const allowOtherBrandTag = async () => {
    try {
      await API.Brand.update({
        brandToken: props.auth.token,
        allowOtherBrandTag: true,
      });
      props.closePopup();

      setTimeout(() => {
        props.showModal({ title: '타 브랜드 태그 허용 완료', text: '타 브랜드 태그 허용이 완료되었습니다.' });
      }, 400);
    } catch (error) {
      setTimeout(() => {
        props.showModal({ title: '타 브랜드 태그 허용 실패', text: '타 브랜드 태그 허용에 실패하였습니다.' });
      }, 400);
    }
  };

  const showAlert = (config?: any) => {
    if (!config?.forceOpen) {
      if (isBlocked()) {
        return;
      }
    }

    props.showPopup({
      width: 480,
      content: () => {
        return (
          <div className="flex flex-col w-[480px] p-10 bg-white rounded-2xl mx-auto">
            <div className="content flex flex-col">
              <div className="flex flex-col items-start py-4">
                <span className="text-[15px] whitespace-pre-wrap leading-5 text-black">
                  <>
                    <img
                      src={'/assets/images/banners/encourage-allow-other-brand-tags-sample.png'}
                      className="w-[228px] h-[228px] mb-[20px]"
                    />
                    <span className="font-bold text-[22px]">
                      “타 브랜드 태그 허용” 하면,
                      <br />
                      원고료 20만원짜리 콘텐츠가 생산됩니다.
                    </span>
                    <br />
                    <br />
                    ✅ 우리 브랜드가 “타 브랜드 태그 허용" 을 해야하는 이유
                    <br />
                    <br />
                    <br />
                    📌 원고료 2만원만 받는 인플루언서가 아니라, 원고료 20-30만원 받는 인플루언서가 우리 제품을 대여할
                    확률이 높아집니다.
                    <br />
                    <br />
                    📌 @나이키모자, @아디다스신발 과 함께 @우리브랜드 가 태그되면, 포스팅의 노출율이 올라갑니다.
                    <br />
                    <br />
                    📌 {getServiceName()} 앱 내에서 우리 브랜드를 상단노출 해주는 로직으로 변경되기 때문에, 대여율이
                    상승합니다.
                    <br />
                  </>
                </span>
              </div>

              <div className="flex flex-col justify-center items-center gap-[10px]">
                <Button
                  className={'w-full py-3 flex justify-center text-center text-base'}
                  textColor={'WHITE'}
                  buttonColor={'BLACK'}
                  textClassName={'font-bold text-[15px]'}
                  text={'클릭 한번으로 타 브랜드 태그 허용하기'}
                  onClick={() => {
                    allowOtherBrandTag();
                  }}
                />

                <Button
                  className={'w-full py-3 flex justify-center text-center text-base'}
                  textColor={'black'}
                  buttonColor={'white'}
                  borderColor={'black'}
                  textClassName={'font-bold text-[15px]'}
                  text={'나중에 하기'}
                  onClick={() => {
                    props.closePopup();
                  }}
                />
              </div>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <>
      {isPanelVisible == false ? null : (
        <>
          <div className="flex flex-col w-full mb-[30px]">
            <img
              className="w-full h-full cursor-pointer"
              src={bannerImage}
              onClick={() => {
                showAlert({ forceOpen: true });
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(EncourageAllowOtherBrandTagPanel);
